import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class SubStdService {
  static getBranchBasedData(stdId, mId, date, businessUnitIds, periodFrom, periodTo, groupIds, isV2 = true, showTotalReportedValue = false) {
    const apiURL = isV2 ? API_ROUTES.BRANCHDATAMETRIC.GETMETRIC_V2 : API_ROUTES.BRANCHDATAMETRIC.GETMETRIC;
    let url = apiURL
      .replace("<standardId>", stdId)
      .replace("<metricId>", mId)
      .replace("<date>", date);
    let appended = false;
    if (businessUnitIds?.length > 0) {
      url += `?businessUnitIds=${businessUnitIds?.toString()}`;
      appended = true;
    }
    if (periodFrom) {
      if (appended) {
        url += `&`;
      } else {
        url += `?`;
      }
      url += `periodFrom=${periodFrom}`;
      appended = true;
    }
    if (periodTo) {
      if (appended) {
        url += `&`;
      } else {
        url += `?`;
      }
      url += `periodTo=${periodTo}`;
      appended = true;
    }
    if (groupIds?.length > 0) {
      if (appended) {
        url += `&`;
      } else {
        url += `?`;
      }
      url += `groupIds=${groupIds?.toString()}`;
      appended = true;
    }
    if (showTotalReportedValue) {
      if (appended) {
        url += `&`;
      } else {
        url += `?`;
      }
      url += `showTotalReportedValue=true`;
      appended = true;
    }
    return HttpUtil.get(url);
  }

  static saveBranchDataPoint(stdId, date, body) {
    return HttpUtil.post(
      API_ROUTES.BRANCHDATAMETRIC.SAVEDATAPOINT.replace("<standardId>", stdId).replace("<date>", date),
      body
    );
  }

  static calculateEquation(metricId, date) {
    return HttpUtil.post(
      API_ROUTES.EQUATIONDATA.CALCULATE.replace("<metricId>", metricId).replace("<date>", date),
      null
    );
  }

  static getBranchBasedComparisonData(filter) {
    return HttpUtil.post(
      API_ROUTES.BRANCHDATAMETRIC.DATA_POINT_CONSOLIDATED, filter);
  }

  static getDocumentsAttached(id) {
    return HttpUtil.get(
      API_ROUTES.BRANCHDATAMETRIC.GET_DOCUMENTS_ATTACHED.replace("<externalId>", id));
  }

  static uploadAttachments(data) {
    return HttpUtil.post(
      API_ROUTES.BRANCHDATAMETRIC.UPLOAD_ATTACHMENTS, data);
  }

  static saveBranchCommentsAttachments(stdId, date, body) {
    return HttpUtil.post(
      API_ROUTES.BRANCHDATAMETRIC.SAVE_COMMENTS_ATTACHMENTS.replace("<standardId>", stdId).replace("<date>", date),
      body
    );
  }
}